import React from 'react';

import { Icon } from '../icons';

export const RefreshV2WithGradientIcon: Icon['component'] = ({ color, style, ...props }) => {
  const colorVars = {
    fill_1: color,
    x1: '0%',
    x2: '100%',
    y1: '0%',
    y2: '100%',
    stopColor1: color,
    stopColor2: color,
  };

  if (color.includes('linear-gradient')) {
    colorVars.fill_1 = 'url(#gradient1)';

    // For 90deg gradient
    colorVars.x1 = '0%';
    colorVars.x2 = '100%';
    colorVars.y1 = '50%';
    colorVars.y2 = '50%';

    colorVars.stopColor1 = color.split(' ')[1];
    colorVars.stopColor2 = color.split(' ')[3];
  }

  return (
    <svg {...props} width="16" height="16" viewBox="0 0 17 16" fill="none" style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3638 7.38271C2.67315 4.26703 5.30267 1.83331 8.5 1.83331C10.7473 1.83331 12.7147 3.03551 13.7927 4.83331H11.8333C11.5572 4.83331 11.3333 5.05717 11.3333 5.33331C11.3333 5.60946 11.5572 5.83331 11.8333 5.83331H14.601C14.6085 5.83348 14.6159 5.83348 14.6234 5.83331H14.7667C15.2637 5.83331 15.6667 5.43037 15.6667 4.93331V1.99998C15.6667 1.72384 15.4428 1.49998 15.1667 1.49998C14.8905 1.49998 14.6667 1.72384 14.6667 1.99998V4.34651C13.4182 2.24377 11.1243 0.833313 8.5 0.833313C4.78353 0.833313 1.72832 3.66183 1.36869 7.28391C1.34141 7.5587 1.54206 7.80358 1.81685 7.83087C2.09164 7.85815 2.33652 7.6575 2.3638 7.38271Z"
        fill={colorVars.fill_1}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6691 8.61726C14.3598 11.7329 11.7303 14.1667 8.53292 14.1667C6.2856 14.1667 4.3182 12.9645 3.2402 11.1667H5.19954C5.47569 11.1667 5.69954 10.9428 5.69954 10.6667C5.69954 10.3905 5.47569 10.1667 5.19954 10.1667H2.43194C2.42448 10.1665 2.417 10.1665 2.4095 10.1667H2.26621C1.76915 10.1667 1.36621 10.5696 1.36621 11.0667V14C1.36621 14.2761 1.59007 14.5 1.86621 14.5C2.14235 14.5 2.36621 14.2761 2.36621 14V11.6534C3.61463 13.7562 5.90861 15.1667 8.53292 15.1667C12.2494 15.1667 15.3046 12.3381 15.6642 8.71606C15.6915 8.44127 15.4909 8.19639 15.2161 8.16911C14.9413 8.14183 14.6964 8.34247 14.6691 8.61726Z"
        fill={colorVars.fill_1}
      />
      <defs>
        <linearGradient
          id="gradient1"
          x1={colorVars.x1}
          y1={colorVars.y1}
          x2={colorVars.x2}
          y2={colorVars.y2}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colorVars.stopColor1} />
          <stop offset="1" stopColor={colorVars.stopColor2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
